import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import React from 'react';

import Radio from 'material-ui-next/Radio/Radio';
import RadioGroup from 'material-ui-next/Radio/RadioGroup';
import FormControlLabel from 'material-ui-next/Form/FormControlLabel';
import FormControl from 'material-ui-next/Form/FormControl';
import FormLabel from 'material-ui-next/Form/FormLabel';

class LevelreqDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      err_msg: '',
      tag: 'min',
      level: 0,
      service: '',
      version: '',
      platform: '',
      system: '',
      open: false
    };

    this.open = this.open.bind(this);
    this.cancel = this.cancel.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  open(data) {
    const { level, service, version, system, platform } = data;

    this.setState({
      level, service, version, system, platform,
      err_msg: '', open: true
    });
  }

  cancel() {
    this.setState({ open: false });
  }

  handleChange(e) {
    this.setState({ tag: e.target.value });
  }

  handleSubmit(e) {
    const { tag, level, service, version, system, platform } = this.state;
    const data = { tag, level, service, version, system, platform };
    this.props.handle_confirm(data, err => {
      if (err) {
        this.setState({ err_msg: err.message });
      } else {
        this.setState({ open: false });
      }
    });
  }

  render() {
    const actions = [
      <FlatButton
        label="Cancel"
        onClick={this.cancel}
      />,
      <FlatButton
        label="Submit"
        keyboardFocused={true}
        onClick={this.handleSubmit}
      />,
    ];

    return (
      <Dialog
        open={this.state.open}
        title="Level Requirement"
        modal={true}
        actions={actions}
        contentStyle={{ width: '250px' }}
      >
        {this.state.err_msg !== '' && (
          <div style={{ color: 'red' }}>
            Not support system: {this.state.system}
          </div>
        )}

        <FormControl component="fieldset" required>
          <FormLabel component="legend">Choose level</FormLabel>
          <RadioGroup
            aria-label="Level"
            name="Level"
            value={this.state.tag}
            onChange={this.handleChange}
          >
            <FormControlLabel value="min" control={<Radio />} label="Minimum" />
            <FormControlLabel value="latest" control={<Radio />} label="Latest" />
          </RadioGroup>
        </FormControl>

      </Dialog>
    );
  }
}

// LevelreqDialog.defaultProps = {
//   submit_edit: null,
//   history: null
// }

export default LevelreqDialog;
// export default validation(strategy)(LevelreqDialog)



// WEBPACK FOOTER //
// ./src/views/admin/levelreq_dialog.react.js